import styled from 'styled-components'
import { TableCell, TableHead as TableHeadMUI, TableRow } from '@mui/material'

const StickyTableCell = styled(TableCell)`
  min-width: 50px;
  left: 0;
  position: sticky;
  z-index: 2;
  background-color: #fff;
`

const TooltipContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const Sticky = ({ children, ...props }) => {
  return <StickyTableCell {...props}>{children}</StickyTableCell>
}

const TableHeadWithoutOrdenation = ({ headCells, groupingTable, ...props }) => {
  return (
    <TableHeadMUI>
      {groupingTable}
      <TableRow>
        {headCells.map(headCell => (
          <>
            {headCell.sticky ? (
              <Sticky
                key={headCell.id}
                align={headCell.align}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                sx={{ color: '#757575' }}
              >
                <TooltipContainer>
                  {headCell.label}
                  {headCell.tooltip}
                </TooltipContainer>
              </Sticky>
            ) : (
              <TableCell
                key={headCell.id}
                align={headCell.align}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                sx={{
                  borderColor: headCell.notSort ? '#FFF' : '#e0e0e0',
                  color: '#757575',
                  ...props?.sxx,
                }}
              >
                {headCell.tooltip ? (
                  <TooltipContainer>
                    {!headCell.notSort && <>{headCell.label}</>}
                    {headCell.tooltip}
                  </TooltipContainer>
                ) : (
                  <>{!headCell.notSort && <>{headCell.label}</>}</>
                )}
              </TableCell>
            )}
          </>
        ))}
      </TableRow>
    </TableHeadMUI>
  )
}

export default TableHeadWithoutOrdenation
